module.exports = __webpack_public_path__ + "img/shogi_2021_pack_4_0008.89be1c29.png";